import React from 'react';
import './ExpiryCaptureOverlay.css';

interface ExpiryCaptureOverlayProps {
  isExtracting: boolean;
  previewUrl?: string | null;
  onCapture: () => void;
  onCancel: () => void;
}

const ExpiryCaptureOverlay: React.FC<ExpiryCaptureOverlayProps> = ({
  isExtracting,
  previewUrl,
  onCapture,
  onCancel,
}) => {
  return (
    <div className="expiry-capture-overlay">
      <div className="expiry-capture-overlay__frame" aria-hidden="true">
        <div className="expiry-capture-overlay__window">
          <div className="expiry-capture-overlay__mask" />
          {previewUrl && (
            <img
              src={previewUrl}
              alt=""
              className="expiry-capture-overlay__preview"
            />
          )}
          <div className="expiry-capture-overlay__corner expiry-capture-overlay__corner--tl" />
          <div className="expiry-capture-overlay__corner expiry-capture-overlay__corner--tr" />
          <div className="expiry-capture-overlay__corner expiry-capture-overlay__corner--bl" />
          <div className="expiry-capture-overlay__corner expiry-capture-overlay__corner--br" />
        </div>
      </div>

      <div className="expiry-capture-overlay__header camera-overlay">
        <div className="expiry-capture-overlay__title">Expiry Capture</div>
        <div className="expiry-capture-overlay__subtitle">
          Align the date inside the center box.
        </div>
      </div>

      <div className="expiry-capture-overlay__actions">
        <button
          type="button"
          className="expiry-capture-overlay__button expiry-capture-overlay__button--secondary camera-overlay"
          onClick={onCancel}
          disabled={isExtracting}
        >
          Cancel
        </button>
        <button
          type="button"
          className="expiry-capture-overlay__button expiry-capture-overlay__button--primary camera-overlay"
          onClick={onCapture}
          disabled={isExtracting}
        >
          {isExtracting ? 'Reading…' : 'Capture'}
        </button>
      </div>
    </div>
  );
};

export default ExpiryCaptureOverlay;
